<scaleForm [formGroup]="scaleForm">
  @for (section of scaleData()?.sections; track section.name) {
    <h2 class="text-xl font-semibold mt-3 mb-3">
      {{ section.label }}
    </h2>

    @for (field of section.fields; track field.key) {
      <mat-card
        class="mb-4"
        appearance="outlined"
        [ngClass]="{ 'bg-transparent!': formMode() === 'filling' }"
      >
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 p-4 items-start">
          <div class="md:col-span-2 space-y-1">
            <h3 class="text-lg font-semibold m-0">{{ field.label }}</h3>
            <p class="text-sm m-0">
              {{ field.description }}
            </p>
            <div class="italic text-xs mt-2">
              @for (
                desc of field.valueDescriptions | keyvalue: numericOrder;
                track desc.key
              ) {
                <div>
                  <strong>{{ desc.key }}</strong
                  >: {{ desc.value }}
                </div>
              }
            </div>
          </div>
          <div class="md:col-span-1 w-full flex flex-col items-center">
            <div class="mb-3 text-center">
              <span class="text-lg font-bold">
                {{ getFieldValue(field) }}
              </span>
              <span class="text-sm"> / {{ field.maxScore }}</span>
            </div>

            <mat-slider
              [disabled]="scaleForm.disabled"
              tabIndex="0"
              [min]="getSliderMin(field)"
              [max]="getSliderMax(field)"
              [discrete]="true"
              [step]="field.allowedValues ? 1 : field.step || 1"
              [displayWith]="formatLabel(field)"
              class="w-full! min-w-37.5"
            >
              <input
                matSliderThumb
                [value]="getSliderCurrentIndex(field)"
                (valueChange)="onSliderChange(field, $event)"
              />
            </mat-slider>

            @if (field.valueDescriptions && getValueDescription(field)) {
              <div
                class="text-sm italic text-gray-600 mt-1 min-h-5 text-center"
              >
                {{ getValueDescription(field) }}
              </div>
            }
          </div>
        </div>
      </mat-card>
    }
  }
</scaleForm>
@for (comp of scaleData()?.computedFields; track comp.key) {
  @if (comp.type === 'number') {
    <div class="text-base font-semibold text-right mt-2">
      {{ comp.label }}:
      <span class="text-2xl ml-2">{{
        scaleForm.get(comp.key)?.value || 0
      }}</span>
      @if (comp.maxScore) {
        <span class="font-normal">/ {{ comp.maxScore }}</span>
      }
    </div>
  }

  @if (comp.type === 'text') {
    <div class="text-right mt-2 text-base">
      <span class="font-semibold">{{ comp.label }}:</span>
      <span class="text-base font-semibold text-primary ml-2">
        {{ scaleForm.get(comp.key)?.value || 'N/A' }}
      </span>
    </div>
  }

  @if (comp.type === 'list') {
    <div class="bg-surface-container rounded-lg p-3 mt-2">
      <h3 class="text-base font-semibold mb-3 text-primary">
        {{ comp.label }}
      </h3>
      <ul class="space-y-2 ms-0 ps-0 list-none">
        @for (section of scaleData()?.sections; track section.name) {
          @for (field of section.fields; track field.key) {
            <li class="text-sm flex items-start">
              <span class="font-semibold w-24 shrink-0"
                >{{ field.label }}:</span
              >
              <div class="flex-1">
                <span class="text-primary font-bold mr-2">{{
                  getFieldValue(field)
                }}</span>
                <span class="italic text-gray-700"
                  >- {{ getValueDescription(field) || 'Nessun valore' }}</span
                >
              </div>
            </li>
          }
        }
      </ul>
    </div>
  }
}
